import { Component, ElementRef, OnInit, Renderer2, ViewChild, inject, input, output } from '@angular/core';
import { MediaService, SvgViewboxDirective } from '@exl-ng/mulo-core';
import { PortalMetrics } from '../../shared/configurations/portal-homepage.constant';
import { I18nService } from '../../core/i18n.service';
import { TranslateModule } from '@ngx-translate/core';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { MatIcon } from '@angular/material/icon';
import { HorizontallerComponent, HorizontallerItemComponent } from '@exl-ng/mulo-common';
import { Dir } from '@angular/cdk/bidi';
import { PieChartModule, BarChartModule, NumberCardModule, ChartCommonModule } from '@swimlane/ngx-charts';
import { NgTemplateOutlet, DecimalPipe } from '@angular/common';

@Component({
    selector: 'esp-portal-metrics',
    templateUrl: './portal-metrics.component.html',
    styleUrls: ['./portal-metrics.component.scss'],
    imports: [
        PieChartModule,
        BarChartModule,
        NumberCardModule,
        Dir,
        NgTemplateOutlet,
        HorizontallerComponent,
        HorizontallerItemComponent,
        MatIcon,
        SvgViewboxDirective,
        ContentLoaderModule,
        ChartCommonModule,
        DecimalPipe,
        TranslateModule
    ]
})
export class PortalMetricsComponent implements OnInit {
    media = inject(MediaService);
    private renderer = inject(Renderer2);
    i18nService = inject(I18nService);

    readonly show = input(false);
    readonly metric = input<'downloads' | 'additions' | 'totals' | null>(null);
    readonly downloadsByCountry = input(undefined);
    readonly totalAssets = input(undefined);
    readonly worksByYear = input(undefined);
    readonly totalWorks = input(undefined);
    readonly loading = input(false);

    readonly focus = output<any>();

    colorScheme = { domain: PortalMetrics.COLORS_SCHEMA };
    showXAxis = true;
    showYAxis = true;
    gradient = true;
    showLegend = false;
    showXAxisLabel = false;
    showYAxisLabel = true;
    noColor = '#ffffff';
    cardColor = this.noColor;
    bandColor = this.noColor;

    // TODO: Skipped for migration because:
    //  Accessor queries cannot be migrated as they are too complex.
    @ViewChild('chart', { read: ElementRef }) set barChart(
        viewBar: ElementRef<Element>
    ) {
        if (viewBar) {
            const svg = viewBar.nativeElement.querySelector(
                'ngx-charts-bar-vertical ngx-charts-chart svg'
            ) as SVGElement;
            if (svg) {
                const title = this.renderer.createElement('title');
                title.innerText = 'Works added by years';
                const desc = this.renderer.createElement('desc') as HTMLElement;
                desc.innerText =
                    'Number of works added by year. Details can be found in table above.';
                svg.prepend(desc);
                svg.prepend(title);
            }
        }
    }

    ngOnInit() {}

    onSelect(event) {}

    onHover(event) {
        this.focus.emit(event);
    }

    onUnHover() {
        this.focus.emit(null);
    }

    useAdvancedAnimation() {
        return !navigator.userAgent.match(/iPhone|iPad|iPod/i);
    }
}
